import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Link from '../../Link/Link'
import Loader from '../../Loader/Loader'
import CommonTable from '../../CommonTable/CommonTable'
import messages from '../../../locale/jsonMessages'
import history from '../../../core/history'
import { getDynamicPolicyName } from '../../../helpers/GetDynamicItemName/getDynamicName'

function CancellationPolicyManagement({ data, loading }) {
  const { formatMessage, locale } = useIntl()


  const thead = () => {
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.policyName) },
      { data: formatMessage(messages.policyContent) },
      { data: formatMessage(messages.editLabel) }
    ]
  }

  const tbody = () => {
    return data?.results?.map((value, key) => {
      const dynamicPolicy = value.dynamicCancellationContent.length > 0 ? getDynamicPolicyName({
        locale,
        data: value.dynamicCancellationContent,
        value
      }) : value
      return {
        id: key,
        data: [
          { data: value?.id },
          { data: dynamicPolicy?.policyName },
          { data: dynamicPolicy?.policyContent },
          {
            data: <div><Link to={"/siteadmin/cancellation-policies/edit/" + value?.id}>
              <FormattedMessage {...messages.editLabel} />
            </Link></div>
          }
        ]
      }
    })
  }

  const handleClick = () => {
    history.push('/siteadmin/cancellation-policies/cancellation-info')
  }

  return (
    <div>
      <div>
        {loading && <div><Loader type={"text"} /></div>}
        {!loading && <div>
          <CommonTable
            title={formatMessage(messages.cancellationPolicyManagement)}
            thead={() => thead()}
            tbody={() => tbody()}
            addAction={() => handleClick()}
            isLink
            redirectionLabel={formatMessage(messages.updateCancellationInfo)}
          />
        </div>}
      </div>

    </div>
  )
}

export default CancellationPolicyManagement